module.exports = __webpack_public_path__ + "media/pop.94cc009c.mp3";